import Vue from 'vue'
import { OktaAuth } from '@okta/okta-auth-js'
import OktaVue from '@okta/okta-vue'
import config from './config'

const oktaAuth = new OktaAuth(config.oidc)

Vue.use(OktaVue, { oktaAuth })
